/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import React, { ComponentType, lazy, Suspense } from 'react';
import Spinner from 'components/ui/Spinner';

interface Opts {
  fallback: React.ReactNode;
}

export type LazyComponent<P> = ((props: P) => JSX.Element) & {
  readonly lazy: 'LAZY';
};

export const lazyLoad = <M, P>(
  importFunc: () => Promise<M>,
  selectorFunc: (s: M) => ComponentType<P>,
  opts: Opts = { fallback: <Spinner /> }
): LazyComponent<P> => {
  const lazyFactory = (): Promise<{ default: ComponentType<P> }> => {
    function FallbackComponent() {
      return <>{opts.fallback}</>;
    }
    return importFunc().then(
      (module) => ({
        default: selectorFunc(module)
      }),
      (e) => {
        console.error(e);

        return { default: FallbackComponent };
      }
    );
  };

  const LazyComponent = lazy(lazyFactory);

  function LazyWrapper(props: P): JSX.Element {
    return (
      <Suspense fallback={opts.fallback}>
        {/* @ts-ignore */}
        <LazyComponent {...props} />
      </Suspense>
    );
  }
  LazyWrapper.lazy = 'LAZY' as const;
  LazyWrapper.displayName = `lazyLoad(${importFunc.name})`;

  return LazyWrapper;
};
